import Vue from 'vue'
import Router from "vue-router"
import {Prop} from "vue-property-decorator";
import {PropElement} from "@/models/prop-element";
import LoginPage from "@/views/LoginPage.vue";


let viewLoader = (name: string): any => {
  return () => import('@/views/' + name + '.vue')
}

let last = (arr: any) => {
  return arr[arr.length - 1]
}

Vue.use(Router)

class FluidRouter {
  constructor(namespace: string) {
    if (namespace !== "") {
      this.namespace = namespace + '/'
    }
  }

  public static _(namespace: string = ""): FluidRouter {
    return new FluidRouter(namespace)
  }

  public routes: any = []
  public namespace: string = ""

  public add(view: string, icon: string = 'mdi-exit-to-app', path: string = '', name: string = '', props: any = {}) {
    if (name == "") {
      name = path
    }

    if (path != "" && this.namespace == "") {
      path = '/' + path
    }
    let viewToLoad = this.namespace + view;
    if (view.charAt(0) === "/") {
      viewToLoad = view.slice(1);
    }

    this.routes.push({
      path: path,
      name: name,
      props: props,
      component: viewLoader(viewToLoad),
      meta: {
        breadcrumb: name,
        icon: icon
      },
    })
    return this
  }

  /*{pageContainer: viewLoader(this.namespace + view), table: viewLoader('UI/Table')} ,
        props: { },*/
  public addNested(path: string, icon: string = 'mdi-exit-to-app', children: FluidRouter) {
    // console.log(path, icon, childrens)

    let isWrapper = !!children.routes[0].children

    this.routes.push({
      path: '/' + path,
      component: viewLoader('UI/Nested'),
      props: isWrapper ? {
        menu: children.routes.map((r: any) => {
          return {
            breadcrumb: r.meta.breadcrumb,
            to: r.name ? r.name : r.children[0].name
          }
        })
      } : undefined,
      meta: {
        breadcrumb: last(path.split('/')),
        icon: icon,
        // Tell me more about doing drugs
        // This is needed to have nested-nested breadcrumbs
        to: isWrapper ? children.routes[0].children[0].name : children.routes[0].name,
      },
      children: children.routes
    })
    return this
  }

}

let routes = FluidRouter._()
  //.add('Dummy', 'mdi-home-analytics', '', 'home')


  .addNested('home', 'mdi-home-analytics',
    FluidRouter._('Home')
      .addNested('home/dashboard', '',
        FluidRouter._('Home')
          .add('Dashboard', '', '', 'dashboard', {})
      )
      .add('/UI/Table', '', 'alarms', '', {
        endpoint: "alarms",
        detail: null,
        headers: [
          {
            text: 'BRAND & PLATE', value: 'brand & plate', type: [
              {text: '', value: 'vehicle.brand_logo', type: "b-avatar"},
              {text: 'Plate', value: 'vehicle.plate', type: "chip"},
            ]
          },
          {
            text: 'ALARMS', value: 'alarms', type: [
              {text: 'Fuel Level', value: 'vehicle.fuel_level', template: "Fuel Level: #%"},
              {text: 'Odometer', value: 'vehicle.odometer', template: "Odometer: #Km"},
              {text: 'Engine', value: 'vehicle.engine_status'},
              {text: 'Doors', value: 'vehicle.door_status'},
            ]
          },
          {
            text: 'DESCRIPTION', value: 'description', type: [
              {text: 'Code', value: 'code', template: "Code: #"},
              {text: 'Source', value: 'source', template: "Source: #"},
              {text: 'Description', value: 'description', template: "Description: #"},
              {text: 'Alarm At', value: 'alarm_at', template: "Alarm At: #"},
            ]
          },
          {
            text: 'POSITION', value: 'position', type: [
              {text: 'Latidude', value: 'position.latitude'},
              {text: 'Longitude', value: 'position.longitude'}
            ]
          },
        ]
      })
  )
  .addNested('people', 'mdi-account-multiple',
    FluidRouter._('People')
      .addNested('people/clients', '',
        FluidRouter._('People')
          .add('/UI/Table', '', '', 'clients', {
            endpoint: "clients",
            detail: "client",
            headers: [
              {text: 'ID', value: 'id'},
              {text: 'STATUS', value: 'status'},
              {text: 'NAME', value: 'main_driver.client_name'},
              {text: 'PHONE(Main Driver)', value: 'main_driver.phone'},
              {text: 'DRVSNum', value: 'drivers', type: "array-length"},
              {text: 'CITY', value: 'address.city'},
              {text: 'PHONE', value: 'phone'},
              {
                text: 'BALANCES', value: 'balances', type: [
                  {text: 'UNPAID', value: 'unpaid_balance', template: "UNPAID: €#"},
                  {text: 'NOT INVOICED', value: 'wallet.balance', template: "NOT INVOICED: €#"},
                ]
              },
              {text: 'ACTIVE SINCE', value: 'created'},
            ]
          })
          .add('ClientDetail', '', ':id', 'client')
      )
      .add('/UI/Table', '', 'drivers', '', {
        endpoint: "drivers",
        detail: "driver",
        headers: [
          {
            text: 'ID', value: 'id', type: [
              {text: 'DRIV', value: 'profile_picture', type: 'avatar'},
              {text: 'ID', value: 'id', type: "chip"},

            ]
          },
          {text: 'STATUS', value: 'status'},
          {text: 'CLIENT', value: 'client_organization_name'},
          {text: 'CITY', value: 'address.city'},
          {
            text: 'PHONE & EMAIL', value: 'phone & email', type: [
              {text: 'PHONE', value: 'phone'},
              {text: 'EMAIL', value: 'email'},
            ]
          },

        ]
      })
      .add('/UI/Table', '', 'subscriptions', '', {
        endpoint: "subscriptions",
        detail: "subscription",
        headers: [
          {
            text: 'SUBSCRIPTION ID & CLIENT', value: 'id', type: [
              {text: 'ID', value: 'id'},
              {text: 'CLIENT', value: 'client.organization_name'},
            ]
          },
          {text: 'PLAN', value: 'plan.name'},
          {text: 'DRIVERS', value: 'plan.max_drivers'},
          {text: 'BILLING_CYCLE', value: 'plan.billing_cycle', template: "*/# days"},
          {
            text: 'EXPIRY', value: 'expiry', type: [
              {text: 'Icon', value: null, type: "icon", template: "mdi-clock-outline"},
              {text: 'EXPIRY', value: 'next_due_date'},
            ]
          },
          {text: 'COST', value: 'plan.cost', template: "#€/month"},
        ]
      })
      .add('/UI/Table', '', 'cards', '', {
        endpoint: "cards",
        detail: "card",
        headers: [
          {
            text: 'CARD NAME & ID', value: 'card name & id', type: [
              {text: 'CARD NAME', value: 'name'},
              {text: 'ID', value: 'id'},
              {text: 'UID', value: 'uid'},
            ]
          },
          {
            text: 'DRIVER', value: 'driver.client_name', type: [
              {text: 'STATUS', value: 'driver.status'},
              {text: 'ID', value: 'driver.id', template: "DR#"},
              {text: 'DRIVER', value: 'driver.client_name'},
            ]
          },
          {text: 'CHIP ID', value: 'chip_id'},
          {text: 'ACTIVE', value: 'enabled'},
          {
            text: 'ID/UID', value: 'id/uid', type: [
              {text: 'ID', value: 'id'},
              {text: 'UID', value: 'uid'},
            ]
          },

        ]
      })
  )

  .addNested('bookings', 'mdi-calendar-multiselect',
    FluidRouter._('Bookings')
      .add('/UI/Table', '', '', 'bookings', {
        endpoint: "reservations",
        detail: "reservation",
        headers: [
          {
            text: 'PICTURES', value: 'pictures', type: [
              {text: 'VEHI', value: 'vehicle.picture_external', type: "b-avatar"},
              {text: 'DRIV', value: 'driver.profile_picture', type: "avatar"},
            ]
          },
          {text: 'ID', value: 'id'},
          {text: 'VEHI', value: 'vehicle.picture_external', type: "b-avatar"},// alt_value: "vehicle.picture_external"},
          {text: 'DRIV', value: 'driver.profile_picture', type: "avatar"},
          {text: 'MODE', value: 'booking_mode'},
          {text: 'DIST', value: 'distance'},
          {text: 'START', value: 'start'},
          {text: 'END', value: 'end'},
          {text: 'PLATE', value: 'vehicle.plate'},
          {text: 'STATUS', value: 'status', type: "chip"},
        ]
      })
      .add('BookingDetail', '', ':id', 'reservation')
  )

  .addNested('assets', 'mdi-car-multiple',
    FluidRouter._('Assets')
      .addNested('assets/vehicles', '',
        FluidRouter._('Assets')
          .add('/UI/Table', '', '', 'vehicles', {
            endpoint: "vehicles",
            detail: "vehicle",
            schemaName: "vehicle",
            actionDelete: false,
            transforms: {
              beforeSave: {
                brand_id: 'brand.id',
                category_id: 'category.id',
                latitude: "position.latitude",
                longitude: "position.longitude"
              },
              edit: {
                brand_id: 'brand.id',
              }
            },
            headers: [
              {text: 'PIC', value: 'picture_external', type: "avatar"},
              {
                text: 'id', value: 'id', type: [
                  {text: 'ID', value: 'id', template: "V#"},
                  {text: 'BRAND', value: 'brand'},
                  {text: 'MODEL', value: 'model'},
                  {text: 'PARKING LOT', value: 'parking_lot.name'},
                ]
              },
              {text: 'PLATE', value: 'plate'},
              {text: 'CATEGORY', value: 'category.name'},
              {text: 'PARKING LOT', value: 'parking_lot.name'},
              {
                text: 'STATUS', value: null, type: [
                  {text: 'FUEL LEVEL', value: 'fuel_level', type: "text-icon", template: "mdi-flash #%"},
                  {text: 'DOOR STATUS', value: null, type: "icon", template: "mdi-key"},
                  {text: 'ENGINE STATUS', value: null, type: "icon", template: "mdi-car"},
                  {text: 'PARKING LOT', value: null, type: "icon", template: "mdi-parking"},
                ]
              },
              {text: 'ACTIONS', value: 'actions', sortable: false},
            ]
          })
          .add('VehicleDetail', '', ':id', 'vehicle')
      )
      .add('/UI/Table', '', 'categories', '', {
        // MAGIC
        endpoint: "vehicle_categories",
        detail: null,
        schemaName: 'vehicle_category',
        actionDelete: false,
        transforms: {
          _: {
            vehicle_type_id: 'vehicle_type.id',
            vehicle_type: null
          },
          copy: {
            id: null
          }
        },
        headers: [
          {text: 'NAME', value: 'name'},
          {text: 'TYPE', value: 'vehicle_type.name'},
          {text: 'DESCRIPTION', value: 'description'},
          {text: 'ACTIONS', value: 'actions', sortable: false},
        ]
      })
      .add('/UI/Table', '', 'types', '', {
        endpoint: "vehicle_types",
        detail: "vehicle_type",
        schemaName: "vehicle_type",
        actionDelete: false,
        actionUpdate: false,
        transforms: {
          _: {

            uid: null
          },
          copy: {
            id: null
          }
        },
        headers: [
          {text: 'ID', value: 'id', template: "VT#"},
          {text: 'TYPE', value: 'name'},
          {text: 'DESCRIPTION', value: 'description'},
          {text: 'ACTIONS', value: 'actions', sortable: false},
        ]
      })
      .add('/UI/TableTabs', '', 'management', '', {
        endpoint: "parking_groups",
        detail: null,
        schemaName: "parking_lot",
        transforms: {
          edit: {
            allowed_zone_id: 'allowed_zone.id',
            forbidden_zone_id: 'forbidden_zone.id',
            undesiderable_zone_id: 'undesiderable_zone.id',
          },
          beforeUpdate: {
            latitude: 'position.latitude',
            longitude: 'position.longitude'

          },
          copy: {
            id: null
          }
        },
        tabData: {tableField: 'parking_lots', groupId: 'id', groupName: 'name'},
        headers: [
          {
            text: 'LOT ID & NAME', value: 'lot id & name', type: [
              {text: 'ID', value: 'id', template: "PL-#"},
              {text: 'NAME', value: 'name'},
            ]
          },
          {text: 'SLOTS', value: 'parking_slots', type: "array-length"},
          {text: 'ACTIONS', value: 'actions', sortable: false},
        ]
      })
      .add('/UI/Table', '', 'notes', '', {
        endpoint: "notes",
        detail: "notes",
        schemaName: "note",
        actionUpdate: false,
        transforms: {
          beforeSave: {
            id: null
          },
          copy: {
            id: null
          }
        },
        headers: [
          {
            text: 'ID & DESCRIPTION', value: 'name & description', type: [
              {text: 'ID', value: 'id', template: "N#"},
              {text: 'DESCRIPTION', value: 'description'},
            ]
          },
          {text: 'RESERVATION', value: 'annotable_id', template: "Reservation: #"},
          {text: 'FROM', value: 'valid_from', template: "From: #"},
          {text: 'TO', value: 'valid_to', template: "To: #"},
          {text: 'ACTIONS', value: 'actions', sortable: false},
        ]
      })
      .add('/UI/Table', '', 'attributes', '', {
        endpoint: "vehicle_attributes",
        detail: "vehicle_attributes",
        schemaName: "vehicle_attribute",
        transforms: {

          beforeSave: {
            vehicle_type_id: 'vehicle_type.id',
            vehicle_type: null,

          },
          beforeUpdate: {
            vehicle_type_id: 'vehicle_type.id',
          },
          copy: {
            id: null
          }
        },
        headers: [
          {text: 'ID', value: 'id', template: "VA#"},
          {
            text: 'NAME DESCRIPTION', value: 'name description', type: [
              {text: 'NAME', value: 'name'},
              {text: 'DESCRIPTION', value: 'description'},
            ]
          },
          {
            text: 'VEHICLE TYPE ID & NAME', value: 'vehicle type id & name', type: [
              {text: 'ID', value: 'id', template: "VT#"},
              {text: 'VEHICLE_TYPE', value: 'vehicle_type.name'},
            ]
          },
          {text: 'TYPE', value: 'type', template: "Type: #"},
          {
            text: 'OTHER', value: 'other', type: [
              {text: 'PRIVATE', value: 'private', template: "Private: #"},
              {text: 'RECOMMENDED', value: 'recommended', template: "Recommended: #"},
            ]
          },
          {text: 'ACTIONS', value: 'actions', sortable: false},
        ]
      })
      .add('/UI/Table', '', 'zones', '', {
        endpoint: "zones",
        detail: null,
        schemaName: "zones",
        headers: [
          {text: 'NAME', value: 'name'},
          {text: 'ACTIONS', value: 'actions', sortable: false},

        ]
      })
  )
  .add('Dummy', 'mdi-map-marker-path', 'service')
  .addNested('billing', 'mdi-cash-register',
    FluidRouter._('Billing')
      .addNested('billing/invoices', '',
        FluidRouter._('Billing')
          .add('/UI/Table', '', '', 'invoices', {
            endpoint: "invoices",
            detail: null,
            headers: [
              {text: 'ID', value: 'id'},
              /*{text: 'CLIENT', value: 'client_organization_name',type: "null"},
             {text: 'PLATE', value: 'plate'},*/

            ]
          })
      )
      .add('/UI/Table', '', 'transactions', '', {
        endpoint: "transactions",
        detail: null,
        headers: [
          {
            text: 'ID', value: 'id', type: [
              {text: 'ID', value: 'id', template: "TR#"},
              {text: 'created', value: 'created'},
            ]
          },
          {text: 'CLIENT', value: 'client_organization_name'},
          {
            text: 'PAYEMENT METHOD (ID & NAME)', value: 'payement method (id & name)', type: [
              {text: 'ID', value: 'payment_method_id', template: "PM#"},
              {text: 'NAME', value: 'payment_name'},
            ]
          },
          {text: 'PT', value: 'invoice.type'},
          {text: 'InternalID', value: 'invoice.internal_id'},
          {text: 'STATUS', value: 'status', type: "chip"},

        ]

      })
  )
  .addNested('support', 'mdi-account-heart',
    FluidRouter._('Support')
      .addNested('support/reporting list', '',
        FluidRouter._('Support')
          .add('/UI/Table', '', '', 'reportings', {
            endpoint: "reportings",
            schemaName: 'reportings',
            detail: 'reporting',
            actionDelete:false,
            headers: [
              {
                text: 'ID', value: 'id', type: [
                  {text: 'ID', value: 'id', template: "RP#"},
                  {text: 'NAME', value: 'type.name'},
                ]
              },
              {
                text: 'DRIVER', value: 'DRIVER', type: [
                  {text: 'DRIVER STATUS', value: 'driver.status', type: "chip"},// alt_value: "vehicle.picture_external"},
                  {text: 'ID', value: 'driver.id', template: "DR#"},
                  {text: 'DRIVER', value: 'driver.name'},
                ]
              },
              {text: 'LOCATION', value: 'location'},
              {
                text: 'VEHICLE', value: 'VEHICLE', type: [
                  {text: 'BRAND', value: 'vehicle.brand', template: "Brand: #"},
                  {text: 'MODEL', value: 'vehicle.model', template: "Model: #"},
                  {text: 'PLATE', value: 'vehicle.plate', type: "chip"},
                ]
              },

              {text: 'REPORTED AT', value: 'created'},
              {text: 'UPDATED AT', value: 'updated'},
              {text: 'STATUS', value: 'status', type: "chip"},
              {text: 'ACTIONS', value: 'actions', sortable: false},
            ]
          })
          .add('ReportingDetail', '', ':id', 'reporting')
      )
      .add('/UI/Table', '', 'reporting types', '', {
        endpoint: "reporting-types",
        detail: "reporting-type",
        headers: [
          {text: 'ID', value: 'id', template: "RT#"},
          {text: 'TYPE', value: 'name'},
          {text: 'DESCRIPTION', value: 'description'},
        ]
      })
      .add('/UI/Table', '', 'instructions', '', {
        endpoint: "instructions",
        detail: "instruction",
        headers: [
          {text: 'ID', value: 'id', template: "IN#"},
          {
            text: 'TITLE', value: 'title', type: [
              {text: 'TITLE', value: 'title'},
              {text: 'SUBTITLE', value: 'subtitle'},
            ]
          },
          {text: 'NR. OF STEPS', value: 'steps', type: "array-length"}
        ]
      })
  )
  .add('Dummy', 'mdi-file-chart', 'reports')
  .addNested('configuration', 'mdi-video-input-component',
    FluidRouter._('Configuration')
      .addNested('configuration/plan list', '',
        FluidRouter._('Configuration')
          .add('/UI/Table', '', '', 'plan', {
            endpoint: "plans",
            detail: "plan",
            withPagination: false,
            headers: [
              {
                text: 'ID', value: '', type: [
                  {text: 'NAME', value: 'name'},
                  {text: 'COST', value: 'cost', template: "€#"},
                  {text: 'DURATION', value: 'cost', template: "duration: # days"},
                ]
              },
              {text: 'STATUS', value: 'status'},
            ]
          })
      )
      .add('/UI/Table', '', 'rates', '', {
        endpoint: "rates",
        detail: "rate",
        withPagination: false,
        headers: [
          {
            text: 'ID & NAME', value: '', type: [
              {text: 'ID', value: 'id', template: "RR#"},
              {text: 'NAME', value: 'name'},
            ]
          },
          {
            text: 'COST', value: 'cost', type: []
          },
        ]
      })
      .add('/UI/Table', '', 'tocs list', '', {
        endpoint: "tocs",
        detail: "toc",
        withPagination: false,
        headers: [
          {
            text: 'ID & NAME', value: '', type: [
              {text: 'ID', value: 'id', template: "TOC#"},
              {text: 'NAME', value: 'name'},
            ]
          },
          {text: 'REQUIRED FROM', value: 'required_from'},
          {text: 'DISABLED', value: 'disabled'},
          {text: 'VERSION', value: 'version'},
        ]
      })
      .add('/UI/Table', '', 'toc types list', '', {
        endpoint: "toc_types",
        detail: "toc_type",
        withPagination: false,
        headers: [
          {
            text: 'ID & NAME', value: '', type: [
              {text: 'ID', value: 'id', template: "TT#"},
              {text: 'NAME', value: 'name'},
            ]
          },
          {text: 'GROUP', value: 'group'},
          {text: 'PRIORITY', value: 'priority'},
        ]
      })
      .add('/UI/Table', '', 'document type list', '', {
        endpoint: "document_types",
        detail: "document_type",
        withPagination: false,
        headers: [
          {
            text: 'ID & NAME', value: '', type: [
              {text: 'ID', value: 'id', template: "DT#"},
              {text: 'DESCRIPTION', value: 'description'},
            ]
          },
          {text: 'ATTACHMENT VIEWS', value: 'attachment_views', type: "two_values_array"},
          {text: 'NUMBER REQUIRED', value: 'has_number'},
          {text: 'EMISSION REQUIRED', value: 'has_emmission'},
          {text: 'EXPIRY REQUIRED', value: 'has_expiry'},
          {text: 'ISSUER REQUIRED', value: 'has_issuer'},
          {text: 'COUNTRY REQUIRED', value: 'has_country'},
        ]
      })
      .add('/UI/Table', '', 'requirement list', '', {
        endpoint: "document_requirements",
        detail: "document_requirement",
        withPagination: false,
        headers: [
          {
            text: 'DOCUMENT TYPE', value: '', type: [
              {text: 'ID', value: 'document_type.id', template: "DT#"},
              {text: 'NAME', value: 'document_type.name'},
            ]
          },
          {
            text: 'ENTITY', value: '', type: [
              {text: 'ID', value: 'vehicle_type.id', template: "VC16#"},
              {text: 'NAME', value: 'vehicle_type.name', template: "VC16#"},
              {text: 'ENTITY', value: 'entity_class'},
            ]
          },
        ]
      })
      .add('/UI/Table', '', 'client type list', '', {
        endpoint: "client_types",
        detail: "client_type",
        withPagination: true,
        headers: [
          {text: 'ID', value: 'id', type: null, template: "CT#"},
          {text: 'TYPE', value: 'type'},

        ]
      })
  )
  //.add('LoginPage', 'mdi-exit-to-app', 'login')
  .add('LogoutPage', 'mdi-exit-to-app', 'logout')
  .add('DevPage', 'mdi-exit-to-app', 'dev')
  .add('InvoiceGallery', 'mdi-credit-card-multiple', 'invoice-gallery')
  .add('GalleryManager', 'mdi-file-document-box', 'gallery')
  .routes


export {routes}

/*export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes

})*/

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes

})
router.addRoutes([{
  path: '/login',
  name: 'login',
  //props: props,
  meta:{breadcrumb: 'login'},
  component:  LoginPage,}])
export default router

router.beforeEach((to, from, next) => {
  let hasToken =  !! localStorage.getItem('argo-token')
  if (to.name == 'login' || hasToken) {
     next()
  } else {
     next({ name: 'login'  } )
  }
})
/*let difference =[]
routes.forEach(function (a, i) {
  Object.keys(a).forEach(function (k) {
    if (a[k] !== myroutes[i][k]) {
      difference.push({ id: myroutes[i].path, key: k, value: myroutes[i][k], index: i });
    }
  });
});

console.log(difference);*/


